export enum ReportLanguage {
  ENGLISH = 'ENGLISH',
  GERMAN = 'GERMAN',
}
export interface BaseModuleReportConfig {
  type: string;
}
export interface HorizonReportReportConfig extends BaseModuleReportConfig {
  type: 'Horizon3 NodeZero';
  subtype: 'internal' | 'external';
  horizonKey: string;
  scanId: string;
  compareTo?: string;
}
export interface NessusModuleReportConfig extends BaseModuleReportConfig {
  type: 'Tenable Nessus';
  scanId: string;
  historyId: string;
  compareTo?: string;
}
export interface DecaretoModuleReportConfig extends BaseModuleReportConfig {
  type: 'Decareto';
  id: string;
}
export interface BreachLenseModuleReportConfig extends BaseModuleReportConfig {
  type: 'Breachlense';
  domain: string;
}
export interface IdentecoModuleReportConfig extends BaseModuleReportConfig {
  type: 'identeco';
  id: string;
}
export type ReportModuleConfig =
  | HorizonReportReportConfig
  | NessusModuleReportConfig
  | DecaretoModuleReportConfig
  | BreachLenseModuleReportConfig
  | IdentecoModuleReportConfig;
export interface ExecutiveReportConfig {
  companyName: string;
  language: ReportLanguage;
  modules: ReportModuleConfig[];
}

export interface ReducedConfiguration {
  numInternalFindings: number;
  numExternalFindings: number;
}

export interface ReportConfig {
  companyName: string;
  scanName: string;
  language: ReportLanguage;
  threshold: number;
  reduced?: boolean;
  reducedConfiguration: ReducedConfiguration;
  modules: ReportModuleConfig[];
}

export interface ClientAccount {
  uuid: string;
  companyName: string;
  companyShortName: string;
}
export interface HorizonScan {
  opId: string;
  opType: string;
  name: string;
  state: string;
  launchedAt: Date;
  completedAt?: Date;
  impactsCount: number;
  weaknessesCount: number;
  hostsCount: number;
}
export interface NessusScan {
  id: string;
  name: string;
}
export interface NessusScanHistory {
  historyId: string;
  uuid: string;
  status: string;
  creationDate: Date;
}
